import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Flex,
  Text,
  Button,
  Modal,
  Stack,
  NumberFormatter,
} from "@mantine/core";

const OdometerMismatchModal = ({
  userValue,
  dealerValue,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  const [confirmValue, setConfirmValue] = useState(null);

  return (
    <Modal opened centered withCloseButton={false} onClose={() => null}>
      <Stack gap="xs">
        {confirmValue ? (
          <>
            <Stack gap="xs">
              <Text size="lg" align="center">
                {t("mixer:vehicle:odometer_mismatch_text_1")}{" "}
                <NumberFormatter
                  value={confirmValue.value}
                  thousandSeparator
                  style={{ fontWeight: 600 }}
                />{" "}
                {t("mixer:vehicle:odometer_mismatch_text_2", {
                  type:
                    confirmValue.type === "customer" ? "the customer" : "me",
                })}
              </Text>
              <Button
                onClick={() => onSubmit(parseInt(confirmValue.value))}
                color="green"
              >
                {t("common:confirm")}
              </Button>
              <Flex justify="center">
                <Button
                  size="xs"
                  color="gray"
                  variant="subtle"
                  onClick={() => setConfirmValue(null)}
                >
                  {t("common:this_is_incorrect")}
                </Button>
              </Flex>
            </Stack>
          </>
        ) : (
          <>
            <Text align="center" size="lg">
              {t("mixer:vehicle:customer_supplied_different_reading")}
            </Text>
            <Text align="center" size="lg" mb="md" fw={600}>
              {t("mixer:vehicle:which_reading_is_correct")}
            </Text>
            <Button
              onClick={() =>
                setConfirmValue({ type: "customer", value: userValue })
              }
            >
              {t("mixer:vehicle:customers_reading")}:{` `}
              <NumberFormatter
                style={{ marginLeft: "4px" }}
                value={userValue}
                thousandSeparator
              />
            </Button>
            <Button
              onClick={() =>
                setConfirmValue({ type: "dealer", value: dealerValue })
              }
            >
              {t("mixer:vehicle:your_reading")}:{` `}
              <NumberFormatter
                style={{ marginLeft: "4px" }}
                value={dealerValue}
                thousandSeparator
              />
            </Button>
            <Button color="red" onClick={onClose}>
              {t("mixer:vehicle:neither_is_correct")}
            </Button>
          </>
        )}
      </Stack>
    </Modal>
  );
};

export default OdometerMismatchModal;
